import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3" }
const _hoisted_2 = { class: "p-3 flex content-main gap-5 pb-[70px]" }
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = {
  key: 0,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pb-3"
}
const _hoisted_5 = { class: "flex justify-between h-[50px] items-center pt-2" }
const _hoisted_6 = {
  key: 1,
  class: "flex gap-3 flex-row w-full items-start mb-3"
}
const _hoisted_7 = { class: "w-2/4" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "w-2/4 mt-[13px]" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5"
}
const _hoisted_12 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Nav),
        (_ctx.can_manage_compliance_settings)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.vg_selectedLocation.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-white font-semibold text-[24px]" }, "Marketplace", -1)),
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                            class: _normalizeClass('bg-white text-theme-green hover:bg-theme-darkgreen rounded  mt-2 px-4 py-2 ')
                          }, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("span", { class: "text-sm tracking-widest font-medium" }, "SAVE", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: _normalizeClass('input-wrapper ' + (_ctx.form.integrationValue.error_type))
                            }, [
                              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs mb-1 font-normal" }, "Leafly Dispensary Menu API Key", -1)),
                              _withDirectives(_createElementVNode("input", {
                                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateFields(['integrationValue']))),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.integrationValue.value) = $event)),
                                placeholder: "[Key example]",
                                type: "text",
                                class: "block rounded bg-gray-black border-none w-full text-sm text-theme-white"
                              }, null, 544), [
                                [_vModelText, _ctx.form.integrationValue.value]
                              ]),
                              (_ctx.form.integrationValue.error_message)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "field-error label-text mt-1",
                                    textContent: _toDisplayString(_ctx.form.integrationValue.error_message)
                                  }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            (!_ctx.loading)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  disabled: !_ctx.haveData,
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.syncMenu()), ["prevent"])),
                                  class: _normalizeClass((!_ctx.haveData ? 'bg-theme-grey text-slatewhite' : 'bg-white text-theme-green hover:bg-theme-darkgreen' ) + ' rounded  mt-2 px-4 py-2 ')
                                }, [...(_cache[7] || (_cache[7] = [
                                  _createElementVNode("span", { class: "text-sm tracking-widest font-medium" }, "Sync", -1)
                                ]))], 10, _hoisted_10))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("p", { class: "text-center text-theme-red mt-3" }, "Please select a location from the top left corner.", -1)
                  ]))]))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("p", { class: "text-center text-theme-red mt-3" }, "Page is restricted.", -1)
            ]))]))
      ])
    ])
  ]))
}